<div class="wrapper">

    <main class="middle-content">
        <div class="page_title_block">
            <h1 class="page_title">Assessments & Forms</h1>
        </div>
        <div class="content-section">
            <div class="main-block-innner">
                <div class="add-store-block input-style mw-100">
                    <div class="form-user">



                        <div class="tab-section">
                            <div class="tab">
                                <button class="tablinks" [ngClass]="tabView == 'Questionnaire' ? 'active': ''"
                                    (click)="viewTab('Questionnaire','view')">Questionnaire</button>
                                <button class="tablinks" [ngClass]="tabView == 'Assessments' ? 'active': ''"
                                    (click)="viewTab('Assessments','view')">Assessments</button>
                            </div>
                        </div>
                        <div class="card">
                            @if(tabView == 'Questionnaire'){
                            <div class="card-body">
                                <div class="row d-flex mb-4 justify-content-end">

                                    <!-- *********************** add title *************************** -->
                                    @if((tabView == 'Questionnaire') && action == 'add'){
                                    <div class="col-md-6 d-flex align-items-baseline">
                                        <label class="card-title col-md-3 text-nowrap">
                                            Title :
                                        </label>
                                        <form [formGroup]="assessmentForm">
                                            <div class="mt-2 mb-4">
                                                <select name="" class="custom-select" formControlName="programValue"
                                                    id="">
                                                    <option value="">Select Program</option>
                                                    @for (item of programList; track item; let i = $index) {
                                                    <option [value]="item._id">
                                                        {{item?.title}}</option>
                                                    }
                                                </select>
                                            </div>
                                        </form>
                                        <!-- <input type="text" [(ngModel)]="titleValue" placeholder="Add Title" class="form-control col-md-9" id=""> -->
                                    </div>
                                    }
                                    <!-- *********************** edit title *************************** -->

                                    <!-- *********************** edit title *************************** -->
                                    <div class="col-md-6 d-flex justify-content-end">
                                        <div class="addQuestion" (click)="viewTab('Questionnaire','add')">
                                            <i class="fa fa-plus-circle"></i>
                                            @if((tabView == 'Questionnaire') && action == 'view'){
                                            <label class="ms-1">Add Questionnaire</label>
                                            }
                                            @if((tabView == 'Questionnaire') && action == 'edit'){
                                            <label class="ms-1"> Add Questionnaire</label>
                                            }
                                        </div>
                                    </div>
                                </div>

                                @if((tabView == 'Questionnaire') && action == 'view'){
                                <div>
                                    <!-- View All questionnaire list api  -->

                                    @if(viewQustionairelist){
                                    <div class="global-table no-radius p0">
                                        <div class="table-responsive">
                                            <table class="table table-bordered">
                                                <thead>
                                                    <tr class="no_wrap_th text-center">
                                                        <th class="Sorting-img"> S.No.</th>
                                                        <th class="Sorting-img">Questionnaire</th>
                                                        <th class="action_td_btn3 Sorting-img">Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    @for (
                                                    item of questionnaireList
                                                    | paginate: {
                                                    itemsPerPage: itemPerPage,
                                                    currentPage: currentPage,
                                                    totalItems: total1
                                                    };
                                                    track item?._id;
                                                    let i = $index
                                                    ) {
                                                    <tr class="text-center">
                                                        <td class="content">
                                                            {{ itemPerPage * (currentPage - 1) + i + 1 }}
                                                        </td>

                                                        <td class="content">
                                                            {{ item?.programId?.title }}
                                                        </td>

                                                        <td>
                                                            <button class="btn btn-info bt-margin" title="view"
                                                                (click)="viewQuestionaire(item?._id)">
                                                                <i class="fa fa-eye" style="color:white"></i>
                                                            </button>

                                                            <button class="btn btn-info ms-2 bt-margin"
                                                                (click)="editQuetionnaire(item?._id)">
                                                                <i class="fa fa-edit" style="color:white"></i>
                                                            </button>

                                                            <button class="btn btn-danger ms-2 bt-margin" title="delete"
                                                                (click)="deleteUserModal(item?._id)">
                                                                <i class="fa fa-trash" style="color:white"></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                    }

                                                    @if(questionnaireList.length == 0){
                                                    <tr>
                                                        <td class="table-no-record" colspan="3">No Record Found</td>
                                                    </tr>}
                                                </tbody>
                                            </table>
                                            @if(total1 > 10){
                                            <div class="custom-pagination mt-3 d-flex justify-content-end">
                                                <pagination-controls
                                                    (pageChange)="questionnaireListApi($event)"></pagination-controls>
                                            </div>
                                            }
                                        </div>
                                    </div>
                                    }

                                    <!-- TO view particular question  -->
                                    @if (viewQuestion && !viewQustionairelist) {
                                    @for (que of viewQuestionnaire; track que; let j = $index) {
                                    <div class="mb-1">
                                        @if (que?.QuestionText) {
                                        <span>{{ j + 1 }}.</span>
                                        }

                                        <label>{{ que?.QuestionText }}</label>

                                        @if (que?.options?.length > 0) {
                                        <div class="pt-2">
                                            @if (que?.QuestionType === 'checkbox') {
                                            <span>Options</span>
                                            }

                                            @for (opt of que.options; track opt; let i = $index) {
                                            @if (opt?.option) {
                                            <span class="ms-3">
                                                {{ i + 1 }}. {{ opt.option || 'NA' }}
                                            </span>
                                            }
                                            }
                                        </div>
                                        }
                                    </div>
                                    }
                                    }

                                </div>
                                }

                                <!-- ********************Add Questions action perform here ************************************-->
                                @if((tabView == 'Questionnaire') && action == 'add'){
                                <div>
                                    <form [formGroup]="quesionform">
                                        <ul class="form-group row px-3" formArrayName="QueArr">
                                            @for (QueArr of quesionform?.controls.QueArr['controls']; track QueArr; let i
                                            =
                                            $index) {
                                            <div class="row p-3 border w-100 mb-3" formGroupName="{{i}}">
                                                <li class="py-2 d-flex">
                                                    <span (click)="addUser('',i)" class="d-flex w-100">
                                                        <label class="addQuestion active">Add New
                                                            Question</label>
                                                        <i class="fa fa-plus addPlus ms-3"></i>
                                                    </span>
                                                    <div class="col-md-6 position-absolute quedrop">
                                                        <select name="" id="" class="custom-select col-md-10"
                                                            (mouseenter)="qustionTypeChange($event.target.value,i)"
                                                            (change)="qustionTypeChange($event.target.value,i)"
                                                            formControlName="QuestionType">
                                                            <option value="">Select question type</option>
                                                            <option value="YESNO">MCQ(radio type question)
                                                            </option>
                                                            <option value="checkbox">Multiple type question
                                                            </option>
                                                            <option value="text">Input type question</option>
                                                        </select>
                                                    </div>
                                                </li>
                                                <li class="py-2 d-flex">
                                                    <span class="me-2">Q {{i+1}}.</span>
                                                    <div style="flex: 1">
                                                        <input type="text" name=""
                                                            placeholder="Type your question in english"
                                                            formControlName="QuestionText" class="form-control" id="">
                                                        <br />
                                                        <input type="text" name=""
                                                            placeholder="Type your question in français"
                                                            formControlName="QuestionTextFR" class="form-control" id="">
                                                        <br />
                                                        <input type="text" name=""
                                                            placeholder="Type your question in español"
                                                            formControlName="QuestionTextES" class="form-control" id="">
                                                    </div>
                                                    @if(quesionform?.controls.QueArr['controls'].length > 1){
                                                    <i (click)="deleteUser(i)" class="fa fa-times addPlus ms-3"
                                                        aria-hidden="true"></i>
                                                    }
                                                </li>
                                                @if(QuestionType == 'checkbox'){
                                                <li class="py-2 d-flex align-items-center">
                                                    <span>Options</span>
                                                </li>
                                                }
                                                <li formArrayName="options">
                                                    @if(questionTypeIndex == i){
                                                    <div>
                                                        @if(QuestionType == 'checkbox'){
                                                        <div>
                                                            @for (options of QueArr.controls.options.controls; track
                                                            options; let j = $index) {
                                                            <div class="align-items-center d-flex my-2"
                                                                formGroupName="{{j}}">
                                                                <input type="text" name="" placeholder="option"
                                                                    formControlName="option"
                                                                    class="form-control col-md-4 ms-3" id="">

                                                                @if(QueArr.controls.options.controls.length < 4){ <i
                                                                    class="fa fa-plus addPlus ms-3"
                                                                    (click)="addoption(i)"></i>
                                                                    }

                                                                    @if(QueArr.controls.options.controls.length > 1){
                                                                    <i (click)="deleteOption(i,j)"
                                                                        class="fa fa-times addPlus ms-3"
                                                                        aria-hidden="true"></i>
                                                                    }
                                                            </div>
                                                            }
                                                        </div>
                                                        }

                                                        @if(QuestionType == 'YESNO'){
                                                        <div class="d-flex align-items-center">
                                                            <div class="d-flex align-items-center">
                                                                <input type="radio" name="typeRadio" id="" disabled>
                                                                <label class="ms-2"> Yes </label>
                                                            </div>
                                                            <div class="d-flex align-items-center">
                                                                <input type="radio" name="typeRadio" disabled
                                                                    class="ms-3" id="">
                                                                <label class="ms-2"> No </label>
                                                            </div>
                                                        </div>
                                                        }

                                                        @if(QuestionType == 'text'){
                                                        <div>
                                                            <!-- <input type="text" placeholder="Type your answer" id="" class="form-control"> -->
                                                        </div>
                                                        }
                                                    </div>
                                                    }
                                                </li>
                                            </div>
                                            }
                                            <li class="my-3 d-flex justify-content-end">
                                                <button class="btn btn-theme" type="submit"
                                                    (click)="addQuestionnaire('true')">Save</button>
                                            </li>
                                        </ul>
                                    </form>
                                </div>
                                }


                                <!-- *************************** Edit Questionnaire action perform here ************************************-->


                            </div>
                            }


                            <!-- ******************************** Questionnaire section end here *********************** -->

                            <!-- ******************************** Assessment section start here *********************** -->

                            @if(tabView == 'Assessments'){
                            <div class="card-body">
                                <div class="row d-flex mb-4 justify-content-end">
                                    <!-- *********************** add title *************************** -->
                                    @if((tabView == 'Assessments') && action == 'add'){
                                    <div class="col-md-8 d-flex">
                                        <form [formGroup]="addAssessmentTitleForm" class="d-flex">
                                            <div class="justify-content-around d-flex">
                                                <label class="card-title col-md-2 text-nowrap">
                                                    Title :
                                                </label>
                                                <div>
                                                    <div>
                                                        <input type="text" name="" placeholder="Add Title in English"
                                                            formControlName="addassessmentTitle"
                                                            class="form-control col-md-12" id="">
                                                        @if(addAssessmentTitleForm.get('addassessmentTitle')?.hasError('required')
                                                        && addAssessmentTitleForm.get('addassessmentTitle')?.dirty){
                                                        <span>
                                                            <small class="text-danger">
                                                                *Title is required.
                                                            </small>
                                                        </span>
                                                        }
                                                    </div>
                                                    <br />
                                                    <div>
                                                        <input type="text" name="" placeholder="Add Title in Français"
                                                            formControlName="addassessmentTitleFR"
                                                            class="form-control col-md-12" id="">
                                                        @if(addAssessmentTitleForm.get('addassessmentTitleFR')?.hasError('required')
                                                        && addAssessmentTitleForm.get('addassessmentTitleFR')?.dirty){
                                                        <span>
                                                            <small class="text-danger">
                                                                *Title is required.
                                                            </small>
                                                        </span>
                                                        }
                                                    </div>
                                                    <br />
                                                    <div>
                                                        <input type="text" name="" placeholder="Add Title in Español"
                                                            formControlName="addassessmentTitleES"
                                                            class="form-control col-md-12" id="">
                                                        @if(addAssessmentTitleForm.get('addassessmentTitleES')?.hasError('required')
                                                        && addAssessmentTitleForm.get('addassessmentTitleES')?.dirty){
                                                        <span>
                                                            <small class="text-danger">
                                                                *Title is required.
                                                            </small>
                                                        </span>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- *************** select program section here ************************* -->
                                            <div class="ms-2">
                                                <select name="" class="custom-select"
                                                    formControlName="addAssessmentProgramValue" id="">
                                                    <option value="" selected>Select Program</option>
                                                    @for (item of programList; track item; let j = $index) {
                                                    <option [value]="item._id">{{item?.title}}</option>
                                                    }
                                                </select>
                                                @if(addAssessmentTitleForm.get('addAssessmentProgramValue')?.hasError('required')
                                                &&
                                                addAssessmentTitleForm.get('addAssessmentProgramValue')?.dirty){
                                                <span>
                                                    <small class="text-danger">
                                                        *Program is required.
                                                    </small>
                                                </span>
                                                }
                                            </div>
                                            <!-- *************** select program section here ********************* -->
                                        </form>
                                    </div>
                                    }
                                    <!-- *********************** edit title *************************** -->

                                    <!-- *********************** edit title *************************** -->
                                    <div class="col-md-4 d-flex justify-content-end">
                                        @if((tabView == 'Assessments') && action == 'view'){
                                        <div class="addQuestion" (click)="viewTab('Assessments','add')">
                                            <i class="fa fa-plus-circle"></i>
                                            <label class="ms-1">Add
                                                Assessments</label>
                                        </div>
                                        }
                                    </div>
                                </div>

                                <!----------------------- All listing of assessment of view here ---------------------- -->
                                @if((tabView == 'Assessments') && action == 'view'){
                                <div>
                                    @if(viewAssessmentlist){
                                    <div class="global-table no-radius p0">
                                        <div class="table-responsive">
                                            <table class="table table-bordered">
                                                <thead>
                                                    <tr class="no_wrap_th text-center">
                                                        <th class="Sorting-img"> S.No.</th>
                                                        <th class="Sorting-img">Assessment title</th>
                                                        <th class="Sorting-img">Assessment title (Français)</th>
                                                        <th class="Sorting-img">Assessment title (Español)</th>
                                                        <th class="action_td_btn3 Sorting-img">Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    @for (
                                                    item of assessmentForm_List
                                                    | paginate: {
                                                    itemsPerPage: itemPerPage,
                                                    currentPage: currentPage,
                                                    totalItems: total
                                                    };
                                                    track item?._id;
                                                    let i = $index
                                                    ) {
                                                    <tr class="text-center">
                                                        <td class="content">
                                                            {{ itemPerPage * (currentPage - 1) + i + 1 }}
                                                        </td>

                                                        <td class="content">{{ item?.title }}</td>
                                                        <td class="content">{{ item?.titleFR }}</td>
                                                        <td class="content">{{ item?.titleES }}</td>

                                                        <td>
                                                            <button class="btn btn-info bt-margin" title="view"
                                                                (click)="viewAssessment(item?._id)">
                                                                <i class="fa fa-eye" style="color:white"></i>
                                                            </button>

                                                            <button class="btn btn-info ms-2 bt-margin"
                                                                (click)="editAssessment(item?._id)">
                                                                <i class="fa fa-edit" style="color:white"></i>
                                                            </button>

                                                            <button class="btn btn-danger ms-2 bt-margin" title="delete"
                                                                (click)="deleteAssessmentModal(item?._id)">
                                                                <i class="fa fa-trash" style="color:white"></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                    }

                                                    @if(questionnaireList.length == 0){
                                                    <tr>
                                                        <td class="table-no-record" colspan="3">No Record Found</td>
                                                    </tr>
                                                    }
                                                </tbody>
                                            </table>
                                            @if(total > 10){
                                            <div class="d-flex justify-content-end mt-3">
                                                <pagination-controls
                                                    (pageChange)="assessmentListApi($event)"></pagination-controls>
                                            </div>
                                            }
                                        </div>
                                    </div>
                                    }

                                    <!-- TO view particular question  -->
                                    @if(viewAssessmentData && !viewAssessmentlist){
                                    <div>
                                        <div class="mrgn-0-auto mt30 order-view">
                                            <div class="form-group row mx-0">
                                                <div class="col-md-12 d-flex">
                                                    <label>Title English: </label>
                                                    <p>
                                                        {{viewAsseessmentData?.title}}
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="form-group row mx-0">
                                                <div class="col-md-12 d-flex">
                                                    <label>Title Français: </label>
                                                    <p>
                                                        {{viewAsseessmentData?.titleFR}}
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="form-group row mx-0">
                                                <div class="col-md-12 d-flex">
                                                    <label>Title Español: </label>
                                                    <p>
                                                        {{viewAsseessmentData?.titleES}}
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="form-group row mx-0">
                                                <div class="col-md-6 d-flex">
                                                    <label>Program : </label>
                                                    <p class="col-md-6">
                                                        {{viewAsseessmentData?.programTitle}}
                                                    </p>
                                                </div>
                                            </div>
                                            <b>Intro English:</b>
                                            <div>
                                                @for (assessment of viewAsseessmentData?.remarks; track assessment; let
                                                i = $index) {
                                                <div class="form-group row mx-0">
                                                    <div class="col-md-12 d-flex">
                                                        <p>{{ assessment }}</p>
                                                    </div>
                                                </div>
                                                }

                                            </div>
                                            <b>Intro Français:</b>
                                            <div>
                                                @for (assessment of viewAsseessmentData?.remarksFR; track assessment;
                                                let i = $index) {
                                                <div class="form-group row mx-0">
                                                    <div class="col-md-12 d-flex">
                                                        <p>{{ assessment }}</p>
                                                    </div>
                                                </div>
                                                }

                                            </div>
                                            <b>Intro Español:</b>
                                            <div>
                                                @for (assessment of viewAsseessmentData?.remarksES; track assessment;
                                                let i = $index) {
                                                <div class="form-group row mx-0">
                                                    <div class="col-md-12 d-flex">
                                                        <p>{{assessment}}</p>
                                                    </div>
                                                </div>
                                                }
                                            </div>
                                            <b>Questions:</b>
                                            <div>
                                                @for (assessment of viewAsseessmentData?.Questions; track assessment;
                                                let i = $index) {
                                                <div class="form-group row mx-0">
                                                    <div class="col-md-12 d-flex">
                                                        Q{{i+1}}.
                                                        <div>
                                                            <p>English: {{assessment?.QuestionText}}</p>
                                                            <p>Français: {{assessment?.QuestionTextFR}}</p>
                                                            <p>Español: {{assessment?.QuestionTextES}}</p>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-12">
                                                        <span>Options</span> <span class="ms-3"> Yes </span> <span
                                                            class="ms-3"> No </span>
                                                        <!-- <span class="ms-3"> Marks  </span> <span class="ms-2"> {{assessment?.marks}} </span> -->
                                                    </div>
                                                </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    }
                                </div>
                                }


                                <!-- **************************** Add Assessments action perform here ************************************-->
                                @if((tabView == 'Assessments') && action == 'add'){
                                <div>
                                    <form [formGroup]="addAssessmentForm">
                                        <b>Intro:</b>
                                        <ul class="form-group row px-3" formArrayName="remarks">
                                            @for (remarks of addAssessmentForm?.controls.remarks['controls']; track
                                            remarks;let i = $index) {
                                            <div class="row p-3 border w-100 mb-3" formGroupName="{{i}}">
                                                <li class="py-2 d-flex">
                                                    <span (click)="addRemark3()" class="d-flex w-100">
                                                        <i class="fa fa-plus addPlus ms-3"></i>
                                                    </span>
                                                </li>
                                                <li class="py-2 d-flex">
                                                    <!-- <span class="me-2">Remark {{i+1}}.</span> -->
                                                    <div style="flex: 1;">
                                                        <input type="text" name=""
                                                            placeholder="Type your remark in English"
                                                            formControlName="remark" class="form-control" id="">
                                                        <br />
                                                        <input type="text" name=""
                                                            placeholder="Type your remark in Français"
                                                            formControlName="remarkFR" class="form-control" id="">
                                                        <br />
                                                        <input type="text" name=""
                                                            placeholder="Type your remark in Español"
                                                            formControlName="remarkES" class="form-control" id="">
                                                    </div>

                                                    @if(addAssessmentForm?.controls.remarks['controls'].length > 1){
                                                    <i (click)="deleteRemark3(i)" class="fa fa-times addPlus ms-3"
                                                        aria-hidden="true"></i>
                                                    }
                                                </li>
                                            </div>
                                            }
                                        </ul>

                                        <b>Questions:</b>
                                        <ul class="form-group row px-3" formArrayName="QueArr3">
                                            @for (QueArr3 of addAssessmentForm?.controls.QueArr3['controls']; track
                                            QueArr3;let i = $index) {
                                            <div class="row p-3 border w-100 mb-3" formGroupName="{{i}}">
                                                <li class="py-2 d-flex">
                                                    <span (click)="addUser3('',i)" class="d-flex w-100">
                                                        <label class="addQuestion active">Add New
                                                            Question</label>
                                                        <i class="fa fa-plus addPlus ms-3"></i>
                                                    </span>
                                                </li>
                                                <li class="py-2 d-flex">
                                                    <span class="me-2">Q{{i+1}}.</span>
                                                    <div style="flex: 1;">
                                                        <input type="text" name=""
                                                            placeholder="Type your assessment English"
                                                            formControlName="assessmentText" class="form-control" id="">
                                                        <br />
                                                        <input type="text" name=""
                                                            placeholder="Type your assessment Français"
                                                            formControlName="assessmentTextFR" class="form-control"
                                                            id="">
                                                        <br />
                                                        <input type="text" name=""
                                                            placeholder="Type your assessment Español"
                                                            formControlName="assessmentTextES" class="form-control"
                                                            id="">
                                                        <br />
                                                    </div>
                                                    @if(addAssessmentForm?.controls.QueArr3['controls'].length > 1){
                                                    <i (click)="deleteUser3(i)" class="fa fa-times addPlus ms-3"
                                                        aria-hidden="true"></i>
                                                    }
                                                </li>
                                                <li>
                                                    <div class="d-flex align-items-center">
                                                        <div class="d-flex align-items-center">
                                                            <input type="radio" name="typeRadio" id="" disabled>
                                                            <label class="ms-2"> Yes </label>
                                                        </div>
                                                        <div class="d-flex align-items-center">
                                                            <input type="radio" name="typeRadio" disabled class="ms-3"
                                                                id="">
                                                            <label class="ms-2"> No </label>
                                                        </div>
                                                    </div>
                                                </li>
                                                <!-- 
                                                        <li class="py-2 d-flex align-items-center">
                                                            <span class="col-md-1 text-start p-0">Marks</span>
                                                     
                                                            <div class="col-md-2">
                                                                <input type="text" (keypress)="service.inputKeyPress($event)" maxlength="2" formControlName="marks" class="form-control" >
                                                               
                                                            </div>
                                                        </li>
                                                    -->
                                            </div>
                                            }

                                            <li class="my-3 d-flex justify-content-end">
                                                <button class="btn btn-theme" (click)="addAssessmentApi()"
                                                    type="submit">Save</button>
                                            </li>
                                        </ul>
                                    </form>
                                </div>
                                }
                                <!-- ********************  Edit Questions action perform here ************************************-->
                            </div>
                            }
                        </div>
                        <!--end tab section  -->
                    </div>
                </div>
            </div>
        </div>
        <!-- Table Responsive End -->
    </main>
</div>



<!-- delete hospital modal Start -->
<div class="modal fade global-modal reset-modal" id="deleteQuestion">
    <div class="modal-dialog max-WT-500">
        <form class="change_password">
            <div class="modal-content">
                <div class="modal-header d-block text-center modal-header-custm">
                    <h5 class="modal-title d-inline-block">Delete Questionnaire</h5>
                </div>
                <div class="modal-inner-content">
                    <div class="modal-body">
                        <div class="text-center modal_flax_height d-flex align-items-center justify-content-center">
                            <div class="w-100">
                                <p>Are you sure you want to delete this Questionnaire?</p>
                                <div class="modal-btn-box">
                                    <button type="submit" class="btn btn-theme"
                                        (click)="deleteQuestionApi()">Yes</button>
                                    <button type="button" class="btn btn-danger ms-2" style="min-width: 100px;"
                                        data-dismiss="modal">No</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>
<!-- end delete hospital modal -->


<!-- delete hospital modal Start -->
<div class="modal fade global-modal reset-modal" id="deleteAssessment">
    <div class="modal-dialog max-WT-500">
        <form class="change_password">
            <div class="modal-content">
                <div class="modal-header d-block text-center modal-header-custm">
                    <h5 class="modal-title d-inline-block">Delete Assessment</h5>
                </div>
                <div class="modal-inner-content">
                    <div class="modal-body">
                        <div class="text-center modal_flax_height d-flex align-items-center justify-content-center">
                            <div class="w-100">
                                <p>Are you sure you want to delete this Assessment?</p>
                                <div class="modal-btn-box">
                                    <button type="submit" class="btn btn-theme"
                                        (click)="deleteAssessmentApi()">Yes</button>
                                    <button type="button" class="btn btn-danger ms-2" style="min-width: 100px;"
                                        data-dismiss="modal">No</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>
<!-- end delete hospital modal -->